import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { get, post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import EditDialog from "../../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import formatTitleWithOptional from "../../OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function Add({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  url
}) {
  const { user } = useUser();
  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    industrialProcess: data?.industrialProcess?._id || "",
    // equipmentType: data?.equipmentType?._id || "",
    uniqueIdOfEquipment: data?.uniqueIdOfEquipment || "",
    industrialEquipment: data?.industrialEquipment?._id || "",
    typeOfEntry: data?.typeOfEntry || "",
    quantityConsumed: {
      value: data?.quantityConsumed?.value || "",
      unit: data?.quantityConsumed?.unit || "",
    },
    density: data?.density || "",
    hours: data?.hours || "",
    calorificValue: {
      value: data?.calorificValue?.value,
      unit: data?.calorificValue?.unit || "",
    },
    remarks: data?.remarks || "",
    editRemarkReason: data?.editRemarkReason || "",
    documents: data?.documents || [],
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uniqueIdOfEquipments, setUniqueIdOfEquipments] = useState("");
  // const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  // const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  }, [data, id]);

  console.log(formData, "formData");

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);

    if(name === "industrialEquipment") {
      setFormData((prevState) => ({
        ...prevState,
        uniqueIdOfEquipment: "",  
      }));
    }
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    if (
      name.startsWith("calorificValue.") ||
      name.startsWith("quantityConsumed.")
    ) {
      const [field, key] = name.split(".");

      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
          [field]: {
            ...prevState[field],
            [key]: value,
          },
        };
        
        // Clear density when unit changes to Tonnes
        if (field === "quantityConsumed" && key === "unit" && value === "Tonnes") {
          updatedState.density = "";
        }
        
        return updatedState;
      });

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      if (name === "equipmentType")
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          industrialEquipment: "",
          typeOfEntry: "",
        }));
      else setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  useEffect(() => {
    async function fetchUniqueIdOfEquipment() {
      const response = await get(`${url}`);
      console.log(response.data.data,formData?.industrialEquipment,"check");
      console.log(response.data.data?.find((el) => el._id === formData?.industrialEquipment),"check1");
      setUniqueIdOfEquipments(response.data.data?.find((el) =>el?._id === formData?.industrialEquipment)?.equipments?.map((el) => el.uniqueID));
    }
    fetchUniqueIdOfEquipment();
  }, [formData?.industrialEquipment]);

  

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    // setSelectedMonth(data?.monthYear?.month || "");
    // setSelectedYear(data?.monthYear?.year || "");
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData2[key] === formData[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      if (input.fieldName === "documents") return;

      // Check for calorificValue  & qunatity Consumed separately
      if (
        input.fieldName === "calorificValue" ||
        input.fieldName === "quantityConsumed"
      ) {
        const cvValue = formData[input.fieldName]?.value || "";
        const cvUnit = formData[input.fieldName]?.unit || "";

        if (
          input.fieldName === "calorificValue" &&
          cvValue === "" &&
          cvUnit === ""
        )
          return;

        if (cvValue === "" || !validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value is required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }

      // if(formData.)
      // if (input.fieldName === "industrialProcess") return;

      // Skip validation for hours and industrialEquipment if not in Individual mode
      if (
        formData.typeOfEntry !== "Individual" &&
        (input.fieldName === "hours" ||
        input.fieldName === "uniqueIdOfEquipment")
      ) {
        return; // Skip validation for these fields
      }

      if (
        input?.fieldName === "hours" &&
        formData?.typeOfEntry === "Individual" &&
        formData?.hours === ""
      )
        return;

      // Validation for density field (only required when unit is Gallon, Liters, or M3)
      if (input.fieldName === "density") {
        const quantityUnit = formData?.quantityConsumed?.unit;
        if (quantityUnit && quantityUnit !== "Tonnes") {
          if (!value || !validateNumber(value)) {
            newErrors[input.fieldName] = "Density is required and must be a valid number.";
          }
        }
        return; // Skip other validations for density
      }

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      // consumptionPeriod:{month:selectedMonth,year:selectedYear}
    };
    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.uniqueIdOfEquipment;
    }
    // Delete density if unit is Tonnes
    if (formData.quantityConsumed?.unit === "Tonnes") {
      delete dataToSend.density;
    }
    if (formData.industrialProcess === "") {
      delete dataToSend.industrialProcess;
      // delete dataToSend.industrialEquipment;
    }
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    // Remove fields that have empty values
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     dataToSend[key] === "" || // Empty strings
    //     (typeof dataToSend[key] === "object" &&
    //       Object.keys(dataToSend[key]).length === 0) // Empty objects
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });
    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;

    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(initialState);
        setUploadedFiles([]);
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    if (
      el.fieldName === "calorificValue" ||
      el.fieldName === "quantityConsumed"
    ) {
      return (
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box sx={{ width: "60%" }}>
            <InputField
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData[el.fieldName]?.value || ""}
              errors={errors[el.fieldName]?.value} // Access error for value
              fieldName={`${el.fieldName}.value`}
            />
          </Box>
          <Box sx={{ width: "40%", mt: "9%" }}>
            <SelectField
              name={`${el.fieldName}.unit`}
              value={formData[el.fieldName]?.unit}
              handleChange={handleChange}
              options={el.options}
              errors={errors[el.fieldName]?.unit} // Access error for unit
              field={`${el.field}.unit`}
              defaultValue="Unit"
            />
          </Box>
        </Box>
      );
    }

    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          errors={errors[el.fieldName]}
          options={el.fieldName === "uniqueIdOfEquipment" ? uniqueIdOfEquipments : el.options}
          url={
            el?.fieldName === "industrialEquipment"
              ? `${el?.url}`
              : el.url
          }
          field={el.field}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }

    // Conditionally render density field based on quantityConsumed unit
    if (el.fieldName === "density") {
      const quantityUnit = formData?.quantityConsumed?.unit;
      // Only show density if unit is Gallon, Liters, or M3 (not Tonnes)
      if (quantityUnit && quantityUnit !== "Tonnes") {
        // Dynamically set adornmentText based on selected unit
        let densityUnit = "";
        if (quantityUnit === "Liters") {
          densityUnit = "Tonnes/Liters";
        } else if (quantityUnit === "M3") {
          densityUnit = "Tonnes/M3";
        } else if (quantityUnit === "SCM") {
          densityUnit = "Tonnes/SCM";
        } else if (quantityUnit === "Gallon") {
          densityUnit = "Tonnes/Gallon";
        }
        
        return (
          <InputField
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            adornmentText={densityUnit}
          />
        );
      }
      return null; // Don't render density when unit is Tonnes or not selected
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""} // Pass error prop
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title} Combustion` : `Add ${title} Combustion`}
        </Typography>
        {inputData.map((el) => {
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "uniqueIdOfEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  console.log("inside", data, formData);
  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default Add;
